import api from '../../../lib/api';
import type {
  PaginatedWorkerConsultations,
  WorkerConsultationPayload,
  WorkerConsultationSummary,
} from './types';

export interface ListWorkerConsultationsParams {
  page?: number;
  pageSize?: number;
  mechanism?: string;
  status?: string;
  from?: string;
  to?: string;
  search?: string;
}

export const fetchWorkerConsultations = async (
  params: ListWorkerConsultationsParams = {},
): Promise<PaginatedWorkerConsultations> => {
  const { data } = await api.get<PaginatedWorkerConsultations>('worker-consultations', { params });
  return data;
};

export const fetchWorkerConsultation = async (id: string): Promise<WorkerConsultationSummary> => {
  const { data } = await api.get<WorkerConsultationSummary>(`worker-consultations/${id}`);
  return data;
};

export const createWorkerConsultation = async (payload: WorkerConsultationPayload) => {
  const { data } = await api.post('worker-consultations', payload);
  return data;
};

export const updateWorkerConsultation = async (
  id: string,
  payload: Partial<WorkerConsultationPayload>,
) => {
  const { data } = await api.put(`worker-consultations/${id}`, payload);
  return data;
};

export const transitionWorkerConsultationStatus = async (
  id: string,
  status: WorkerConsultationSummary['status'],
) => {
  const { data } = await api.patch(`worker-consultations/${id}/status`, { status });
  return data;
};
